/******/ (() => {
  // webpackBootstrap
  class CartQuantity extends HTMLElement {
    constructor() {
      super();
      this.removeButton = this.querySelector("[data-cart-remove-item]");
      this.adjustButtons = this.querySelectorAll("[data-cart-quantity-button]");
      this.input = this.querySelector("[data-cart-quantity-input]");
      this.cartCountIndicator = document.querySelector(
        "[data-cart-count-indicator]"
      );
      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleQuantityChange = this.handleQuantityChange.bind(this);
      this.handleRemoveItem = this.handleRemoveItem.bind(this);
      this.updateCart = this.updateCart.bind(this);
      this.updateLineItem = this.updateLineItem.bind(this);
      this.updateCartCountIndicator = this.updateCartCountIndicator.bind(this);
      this.handleCartErrors = this.handleCartErrors.bind(this);
      this.setLoadingState = this.setLoadingState.bind(this);
      this.hideLoadingState = this.hideLoadingState.bind(this);
    }

    connectedCallback() {
      window.wetheme.webcomponentRegistry.register({
        key: "component-cart-quantity",
      });
      this.removeButton?.addEventListener("click", this.handleRemoveItem);
      this.adjustButtons.forEach((button) =>
        button.addEventListener("click", this.handleButtonClick)
      );
      this.input?.addEventListener("change", this.handleInputChange);
    }

    handleButtonClick(e) {
      /* ===== Handle the button click event ===== */
      e.preventDefault();
      const previousValue = this.input.value;
      const adjustment = e.currentTarget.name === "plus" ? 1 : -1;

      // Adjust the quantity by the adjustment value
      this.adjustQuantity(adjustment);

      // Process the new quantity if quantity has changed
      if (previousValue !== this.input.value) {
        this.handleQuantityChange(this.input.value);
      }
    }

    adjustQuantity(adjustment) {
      /* ===== Adjust the quantity by the adjustment value ===== */
      const newValue = parseInt(this.input.value) + adjustment;
      // If the new value is not a number, set it to 1
      this.input.value = isNaN(newValue) ? 1 : newValue;

      // If the value is smaller than the min attribute, set it to the min attribute
      if (
        this.input.min &&
        parseInt(this.input.value) < parseInt(this.input.min)
      ) {
        this.input.value = this.input.min;
      }
    }

    handleInputChange(e) {
      /* ===== Handle the change event ===== */
      e.preventDefault();

      // If the value is not a number, set it to 1
      if (isNaN(this.input.value)) {
        this.input.value = 1;
      }

      // If the value is smaller than the min attribute, set it to the min attribute
      if (
        this.input.min &&
        parseInt(this.input.value) < parseInt(this.input.min)
      ) {
        this.input.value = this.input.min;
      }

      // Process the new quantity
      this.handleQuantityChange(this.input.value);
    }

    async handleQuantityChange(inputValue) {
      /* ===== Update the cart with the new quantity ===== */
      const quantity = parseInt(inputValue);
      await this.updateCart(this.itemIndex, quantity);
    }

    handleRemoveItem() {
      /* ===== Set quantity of line item to zero ===== */
      this.updateCart(this.itemIndex, 0);
    }

    async updateCart(line, quantity) {
      try {
        /* ===== Set the loading state ===== */
        this.setLoadingState();

        const previousCart = await this.getCart();
        const previousItem = previousCart.items[line - 1];
        const hadTwoExtras =
          (previousItem?.properties?.print_on_both_sides?.includes("+") &&
          previousItem?.properties?.add_text_on_design?.includes("+")) || 
          (previousItem?.properties?.second_add_text_on_sleeve?.includes("+") &&
          previousItem?.properties?.add_text_on_sleeve?.includes("+"));

        /* ===== Update the line item quantity ===== */
        let response = await this.updateLineItem(line, quantity);
        if (!response) return;

        const cart = await this.getCart();
        const item = cart.items[line - 1];
        const extras = cart.items.filter(
          (i) =>
            i.id === 49183867863320 ||
            i.id === 49196422234392 ||
            i.id === 49365684257048 ||
            i.id === 49365685174552 ||
            i.id === 49576708210968 ||
            i.id === 49406041456920 ||
            i.id === 49763948298520 ||
            i.id === 49764651467032
        );

        const hasTwoExtras =
          (item?.properties?.print_on_both_sides?.includes("+") &&
          item?.properties?.add_text_on_design?.includes("+")) || 
          (item?.properties?.second_add_text_on_sleeve?.includes("+") &&
          item?.properties?.add_text_on_sleeve?.includes("+"));

        if (item && quantity > 0) {
          if (hasTwoExtras) {
            const itemProperties = Object.entries(item.properties).filter((i) =>
              i[1].includes("+")
            );
            const prices = [];

            if (itemProperties)
              itemProperties.forEach((i) =>
                prices.push(i[1].split("$")[1].slice(0, -1))
              );

            const extra1 = extras.find((e) =>
              prices.some((p) => e.product_description.includes(p))
            );

            if (extra1 && cart.items.indexOf(extra1) >= 0) {
              response = await this.updateLineItem(
                cart.items.indexOf(extra1) + 1,
                previousItem.quantity > quantity
                  ? extra1.quantity - 1
                  : extra1.quantity + 1
              );
            }

            const extra2 = extras.find((e) =>
              prices.some(
                (p) => e !== extra1 && e.product_description.includes(p)
              )
            );

            if (extra2 && cart.items.indexOf(extra2) >= 0) {
              response = await this.updateLineItem(
                cart.items.indexOf(extra2) + 1,
                previousItem.quantity > quantity
                  ? extra2.quantity - 1
                  : extra2.quantity + 1
              );
            }
          }
        } else {
          if (hadTwoExtras) {
            localStorage.setItem("cart_product", JSON.stringify(previousItem));
            localStorage.setItem(
              "cart_product_quantity",
              JSON.stringify(quantity)
            );
          }
        }

        if (extras.length > 0 && !hasTwoExtras && !hadTwoExtras) {
          if (item && quantity > 0) {
            const itemProperty = Object.entries(item.properties).find((i) =>
              i[1].includes("+")
            );
            const price = itemProperty
              ? itemProperty[1].split("$")[1].slice(0, -1)
              : "";
            const extra = price
              ? extras.find((e) => e.product_description.includes(price))
              : "";

            if (extra)
              response = await this.updateLineItem(
                cart.items.indexOf(extra) + 1,
                previousItem.quantity > quantity
                  ? extra.quantity - 1
                  : extra.quantity + 1
              );
          } else {
            const itemProperty = Object.entries(previousItem.properties).find(
              (i) => i[1].includes("+")
            );
            const price = itemProperty
              ? itemProperty[1].split("$")[1].slice(0, -1)
              : "";
            const extra = price
              ? extras.find((e) => e.product_description.includes(price))
              : "";

            if (extra)
              response = await this.updateLineItem(
                cart.items.indexOf(extra) + 1,
                !quantity
                  ? extra.quantity - previousItem.quantity
                  : extra.quantity - 1
              );
          }
        }

        /* ===== If successful response and has gift wrap, update the gift wrap product quantity ===== */
        if (this.hasGiftWrap) {
          const adjustment = quantity - this.previousQuantity;
          if (this.getGiftWrapLine(cart) && this.getGiftWrapQuantity(cart)) {
            response = await this.updateLineItem(
              this.getGiftWrapLine(cart),
              this.getGiftWrapQuantity(cart) + adjustment
            );
          }
        }
        if (!response) return;

        /* ===== If successful response, re-render the cart ===== */
        window.eventBus.emit("update:cart:drawer", response);

        /* ===== Update cart count ===== */
        this.updateCartCountIndicator();
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    }

    async updateExtraItems(previousItem, quantity) {
      if (previousItem && previousItem.properties) {
        try {
          const newQuantity = Number(quantity);
          let response = "";

          const cart = await this.getCart();

          const extras = cart.items.filter(
            (i) =>
              i.id === 49183867863320 ||
              i.id === 49196422234392 ||
              i.id === 49365684257048 ||
              i.id === 49365685174552 ||
              i.id === 49576708210968 ||
              i.id === 49406041456920 || 
              i.id === 49763948298520 ||
              i.id === 49764651467032
          );

          const findLineByVariantId = (extra) => {
            const titleLinks = document.querySelectorAll(
              ".cart-drawer__product_card--title a"
            );

            for (const link of titleLinks) {
              if (link.href.includes(extra.id)) {
                const line = link.getAttribute("line");

                if (line) {
                  return Number(line);
                }
              }
            }
            console.error(`Line not found for variant ID: ${extra.id}`);
            return null;
          };

          const itemProperties = Object.entries(previousItem.properties).filter(
            (i) => i[1].includes("+")
          );

          const prices = [];

          if (itemProperties)
            itemProperties.forEach((i) =>
              prices.push(i[1].split("$")[1].slice(0, -1))
            );

          const extra1 = extras.find((e) =>
            prices.some((p) => e.product_description.includes(p))
          );

          const line1 = findLineByVariantId(extra1);

          if (extra1) {
            response = await this.updateLineItem(
              line1,
              !newQuantity
                ? extra1.quantity - previousItem.quantity
                : extra1.quantity - 1
            );
          }

          const extra2 = extras.find((e) =>
            prices.some(
              (p) => e !== extra1 && e.product_description.includes(p)
            )
          );

          const line2 = findLineByVariantId(extra2);

          if (extra2) {
            response = await this.updateLineItem(
              line2 - 1,
              !newQuantity
                ? extra2.quantity - previousItem.quantity
                : extra2.quantity - 1
            );
          }

          window.eventBus.emit("update:cart:drawer", response);
          this.updateCartCountIndicator();
        } catch (error) {
          console.error("Wasn't possible to fetch data", error);
        }
      }
    }

    async updateLineItem(line, quantity) {
      if (line === null) {
        console.error("Invalid line: cannot update cart item without a line.");
        return;
      }

      if (quantity < 0) {
        console.error("Invalid quantity: cannot set a negative value.");
        return;
      }

      try {
        /* ===== Update line item quantity ===== */
        const body = JSON.stringify({
          line,
          quantity,
          sections: "cart-drawer",
        });

        const response = await fetch(window.routes.cart_change_url, {
          ...this.fetchConfig(),
          body,
        });

        const responseText = await response.text();

        if (!responseText) {
          this.handleCartErrors();
          return null;
        }

        const parsedResponse = JSON.parse(responseText);

        /* ===== Handle errors ===== */
        if (parsedResponse.errors) {
          this.handleCartErrors(line, parsedResponse.errors);
          return null;
        }

        return parsedResponse;
      } catch (error) {
        console.error("Error updating cart line item:", error);
      }
    }

    fetchConfig(type = "json") {
      /* ===== Create the fetch configuration object ===== */
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`,
        },
      };
    }

    handleCartErrors(line, errors) {
      /* ===== Reset loading state and input value ===== */
      this.hideLoadingState();
      this.input.value = this.input.getAttribute("value");

      /* ===== Display the error message ===== */
      this.renderErrorMessage(line, errors);
    }

    renderErrorMessage(line, message) {
      /* ===== Display the error message ===== */
      const errorElement = document.querySelector(
        `[data-cart-error-index="${line}"]`
      );
      if (!errorElement) return;
      errorElement.innerHTML = message;
      errorElement.setAttribute("aria-hidden", false);

      /* ===== If we're at the bottom of the cart, scroll error message into view ===== */
      const isLastItem =
        errorElement.getAttribute("data-cart-is-last-item") === "true";
      if (isLastItem) {
        errorElement.scrollIntoView({ behavior: "smooth" });
      }
    }

    async getCart() {
      /* ===== Fetch the cart information ===== */
      try {
        const response = await fetch(`${window.routes.cart_url}?view=compare`);
        return await response.json();
      } catch (error) {
        console.error(
          `Error fetching cart: ${error.description || error.message}`
        );
      }
    }

    updateCartCountIndicator() {
      /* ===== Update the cart count indicator ===== */
      if (!this.cartCountIndicator) return;
      this.getCart().then((cart) => window.wetheme.updateCartCount(cart));
    }

    getGiftWrapLine(cart) {
      return (
        cart.items.findIndex(
          (item) => item.variant_id === this.giftWrapVariantId
        ) + 1 || null
      );
    }

    getGiftWrapQuantity(cart) {
      return (
        cart.items.find((item) => item.variant_id === this.giftWrapVariantId)
          ?.quantity || null
      );
    }

    setLoadingState() {
      this.classList.add("is-loading");
    }

    hideLoadingState() {
      this.classList.remove("is-loading");
    }

    get itemIndex() {
      return parseInt(this.getAttribute("data-item-index"));
    }

    get previousQuantity() {
      return parseInt(this.getAttribute("data-item-quantity"));
    }

    get hasGiftWrap() {
      return this.getAttribute("data-has-gift-wrap") === "true";
    }

    get giftWrapVariantId() {
      return parseInt(this.getAttribute("data-gift-wrap-variant-id"));
    }
  }

  customElements.define("cart-quantity", CartQuantity);
  window.CartQuantity = CartQuantity;
  /******/
})();
